class Radio extends React.Component {
  render () {
    return (
      <li className="section__item">
        <h3 className="section__item-title" id="radio">
          Radio
          <span className="section__item-docs">
            Documentation: <a href="docs/scss#elements-mixin-radio" target="_blank">SCSS</a>
          </span>
        </h3>
        <div className="section__demo">
         <Collapser>
            <div className="demo">
              <h4 className="demo__title">Simple radio buttons</h4>
              <div className="demo__code">
                <CodeBlock lang="html">
                {`
<div class="radio-demo">
  <div class="row">
    <input class="lipstick" type="radio" name="radio-demo" id="radio-char" value="Charizard" />
    <label for="radio-char">Charizard</label>
  </div>
  <div class="row">
    <input type="radio" name="radio-demo" id="radio-blas" value="Blastoise" checked />
    <label for="radio-blas">Blastoise</label>
  </div>
  <div class="row">
    <input type="radio" name="radio-demo" id="radio-ven" value="Venasaur" />
    <label for="radio-ven">Venasaur</label>
  </div>
</div>
                `}
                </CodeBlock>
                <CodeBlock lang="scss">
                {`
.radio-demo {
  input[type='radio'] {
    @include radio($pure-black);

    &.lipstick {
      @include radio($lipstick);
    }
  }
}

                `}
                </CodeBlock>
              </div>
              <div className="demo__output">
                <Output>
                  <div className="radio-demo">
                    <div className="row">
                      <input className="lipstick" type="radio" name="radio-demo" id="radio-char" value="Charizard" />
                      <label htmlFor="radio-char">Charizard</label>
                    </div>
                    <div className="row">
                      <input type="radio" name="radio-demo" id="radio-blas" value="Blastoise" defaultChecked={true} />
                      <label htmlFor="radio-blas">Blastoise</label>
                    </div>
                    <div className="row">
                      <input type="radio" name="radio-demo" id="radio-ven" value="Venasaur" />
                      <label htmlFor="radio-ven">Venasaur</label>
                    </div>
                  </div>
                </Output>
              </div>
            </div>
          </Collapser>
        </div>
      </li>
    );
  }
};
